import { orderBy, findIndex, get } from 'lodash';
import BaseModel from './BaseModel';
export default class Page extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.title = data.title || this.translate.title || undefined;
        this.urlSlug = data.urlSlug || undefined;
        this.description = data.description || this.translate.description || undefined;
        this.content = data.content || this.translate.content || undefined;
        this.createdDate = data.createdDate || undefined;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            title: this.title,
            description: this.description,
            content: this.content,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                pageId: this.translate.pageId || this.id,
                title: this.title,
                description: this.description,
                content: this.content,
                languageCode: this.languageCode,
            }
        }
        return result;
    }

}
